import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css";

export default function WhatsAppButton(props) {
  return (
    <div className="whats-app-btn-wrapper">
      <a
        href={props.whatsAppNumber}
        rel="noopener noreferrer"
        className="whats-app-btn-link"
        target="_blank"
        aria-label="Entre em contato via WhatsApp"
      >
        <div className="whats-app-btn-container">
          <div id="whats-app-floating-btn">
            <FaWhatsapp className="whats-app-btn-icon" />
          </div>
          <h4>
            FAÇA SEU PLANO
            <br /> E CONCORRA
          </h4>
        </div>
      </a>
    </div>
  );
}
